import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, mergeMap, catchError, withLatestFrom, concatMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';

import * as fromSelectors from './../../store/selectors/test9.selectors';
import { Test9ActionTypes } from '../actions/test9.actions';
import { Test9Service } from '../../../../app1/src/app/services/test9.service';
import { Movie } from '../../models/movie';

@Injectable()
export class Test9Effects {

  constructor(
    private actions$: Actions,
    private test9Service: Test9Service,
    private store: Store
  ) { }


  loadMovies$ = createEffect((): any => {

    return this.actions$.pipe(

      ofType(Test9ActionTypes.loadMovies),

      mergeMap(() => {

        return this.test9Service.getMovies()
          .pipe(
            map((data: any) => {
              //map(data => ({ type: Test9ActionTypes.loadMoviesSuccess, data: data })),
              return { type: Test9ActionTypes.loadMoviesSuccess, data: data }
            }),
            //catchError((error: string) => handleErrors(error))
            catchError((error: string) => {

              return of({ type: Test9ActionTypes.loadMoviesFailure, error: error });
            })
          )
      }

      )
    )
  }, { dispatch: true }

  );


  addMovie$ = createEffect((): any => {

    return this.actions$.pipe(

      ofType(Test9ActionTypes.addMovie),

      tap((moviePassed) => console.log("Add movie test 9:" + moviePassed)),

      concatMap((moviePassed: any) => {

        return this.test9Service.addMovie(moviePassed)
          .pipe(
            map((moviePassed: Movie) => {
              return ({ type: Test9ActionTypes.addMovieSuccess, movie: moviePassed })
            }

            ),
            //catchError((error: string) => handleErrors(error))
            catchError((error: string) => {
              return of({ type: Test9ActionTypes.addMovieFailure, error: error });
            })
          )
      }


      )

    )
  }

  );

  updateMovie$ = createEffect((): any => {

    return this.actions$.pipe(

      ofType(Test9ActionTypes.updateMovie),

      tap((moviePassed) => console.log("update movie test 9:" + moviePassed)),

      concatMap((moviePassed: any) => {

        return this.test9Service.updateMovie(moviePassed)
          .pipe(
            map((moviePassed: Movie) => {

              return ({ type: Test9ActionTypes.updateMovieSuccess, movie: moviePassed })
            }

            ),
            catchError((error: string) => {
              return of({ type: Test9ActionTypes.updateMovieFailure, error: error });
            })
          )
      }


      )

    )
  }

  );


  deleteMovie$ = createEffect((): any => {

    return this.actions$.pipe(

      ofType(Test9ActionTypes.deleteMovie),

      tap((objectPassed) => console.log("delete movie test 9 with id:" + objectPassed)),

      mergeMap((objectPassed: any) => {

        let movieIdToDelete: number = objectPassed.movieId;

        return this.test9Service.deleteMovie(movieIdToDelete)
          .pipe(
            map((objectPassed: Movie) => {

              return ({ type: Test9ActionTypes.deleteMovieSuccess, movie: objectPassed })
            }

            ),
            catchError((error: string) => {
              return of({ type: Test9ActionTypes.deleteMovieFailure, error: error });
            })
          )
      }


      )

    )
  }

  );

}

function handleErrors(error: string) {
  return of({ type: Test9ActionTypes.loadMoviesFailure, error: error });
}

